/* @flow */

export const BLOCKS_UPDATED: string = 'calendar@edito:BLOCKS_UPDATED';

export const updateBlocks = (blocks: Array<EditorialBlock>) => ({
  type: BLOCKS_UPDATED,
  blocks,
});



// WEBPACK FOOTER //
// ./src/modules/calendar/actions/edito.js